// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2T044","title":"FrontImage_title__2K5N3"};